export default "__VITE_ASSET__LRstj8Bz__"